import React from "react";
import { Card, Placeholder } from "react-bootstrap";
import DstButton from "../DstButton/DstButton";
import { Quiz } from "./CardQuiz.d";
import { QUIZ_CATEGORIES } from "../../models/quizCategory";

const _intToHexColor = (color: number) =>
  `#${color.toString(16).padStart(6, "0")}`;

const CardQuiz = ({ quiz, mock = false }: { quiz?: Quiz; mock?: boolean }) => {
  if (mock) {
    return (
      <Placeholder as="div" animation="glow" role="mockup">
        <Card
          className="h-100 px-2 py-3 shadow-sm rounded-plus"
          style={{
            border: "none",
            borderTop: "3px solid var(--gray-10)",
          }}
        >
          <Card.Body className="d-flex flex-column justify-content-between">
            <div>
              <Placeholder as="h5" xs={8} className="mb-3" />

              <div className="mb-3">
                <Placeholder xs={12} className="d-block mb-2" />
                <Placeholder xs={12} className="d-block mb-2" />
                <Placeholder xs={10} className="d-block" />
              </div>

              <div className="d-flex flex-wrap gap-2 mb-3">
                {[...Array(3)].map((_, index) => (
                  <Placeholder
                    key={`quiz-mock-tag-${index}`}
                    as="span"
                    xs={3}
                    className="rounded-pill"
                    style={{ height: 24 }}
                  />
                ))}
              </div>
            </div>

            <Placeholder
              xs={5}
              className="btn btn-outline-dark px-3 py-1 mt-2"
            />
          </Card.Body>
        </Card>
      </Placeholder>
    );
  }

  if (!quiz) return null;

  return (
    <Card
      className="h-100 px-2 py-3 shadow-sm rounded-plus"
      style={{
        border: "none",
        borderTop: `3px solid ${
          QUIZ_CATEGORIES[quiz.category]?.color ?? "var(--gray-10)"
        }`,
      }}
    >
      <Card.Body className="d-flex flex-column justify-content-between">
        <div>
          <Card.Title className="h5">{quiz.title}</Card.Title>
          <p className="text-muted font-s">
            {quiz.question} <br />
            {quiz.resume}
          </p>
          <div className="d-flex flex-wrap gap-2 mb-3">
            {quiz.tags?.map((tag, index) => (
              <span
                key={`tag-${index}`}
                className="badge rounded-pill px-2 py-1 font-xs fw-normal"
                style={{
                  backgroundColor: _intToHexColor(tag.background_color),
                  color: _intToHexColor(tag.text_color),
                }}
              >
                {tag.text}
              </span>
            ))}
          </div>
        </div>
        <DstButton
          btnClass="px-3 py-2 font-s mt-3 w-auto align-self-start"
          variant="outline-dark"
          aria-label={`Commencer ${quiz.title}`}
          value="Commencer"
          link={quiz.link}
        />
      </Card.Body>
    </Card>
  );
};

export default CardQuiz;
